<script>
  // One grey box per picked product (photo, name, and an optional description shown on that product's card in the
  // campaign pop-up), following the chip picker above it. It posts the picked products in chip order, as the form's
  // `<fieldPrefix>[products][<n>][product_id]` and `[description]` fields.
  let { editor, fieldPrefix } = $props()

  // The box starts one line tall and grows with its text: CSS `field-sizing` where the browser has it, otherwise
  // its height follows the text on input.
  const sizesItself = typeof CSS !== 'undefined' && CSS.supports?.('field-sizing', 'content')

  function autosize(node) {
    if (sizesItself) return
    const resize = () => {
      node.style.height = 'auto'
      node.style.height = `${node.scrollHeight}px`
    }
    resize()
    node.addEventListener('input', resize)
    return { destroy: () => node.removeEventListener('input', resize) }
  }
</script>

{#each editor.products as product, index (product.id)}
  <div class="field-box suite-form space-y-2">
    <input type="hidden" name={`${fieldPrefix}[products][${index}][product_id]`} value={product.id} />
    <div class="flex items-center gap-3">
      {#if product.image_url}
        <img src={product.image_url} alt="" class="h-10 w-10 rounded-lg border border-gray-200 bg-white object-contain" />
      {/if}
      <span class="text-sm font-semibold text-gray-900">{product.name}</span>
    </div>
    <div class="form-field-focus-hint text optional">
      <div class="input-wrapper">
        <textarea
          name={`${fieldPrefix}[products][${index}][description]`}
          bind:value={product.description}
          rows="1"
          class="text optional resize-none [field-sizing:content]"
          aria-label={`Description for ${product.name}`}
          placeholder="Description (optional), shown on this product's card"
          use:autosize
        ></textarea>
      </div>
    </div>
  </div>
{/each}
